export default {
  credentialsModal: {
    kioskCode: "Codice dispositivo",
    password: "Password",
    qrHelp:
      "Scansiona questo QR dalla schermata di login del tablet per compilare automaticamente le credenziali.",
    securityWarningTitle: "Avviso di sicurezza:",
    securityWarningBody:
      "chiunque scansioni questo QR può accedere finché non rigeneri la password.",
  },
  posConfig: {
    title: "Collega un lettore",
    linkedReaderTitle: "Lettore collegato",
    readerId: "Id lettore provider",
    refreshFromSumup: "Aggiorna da SumUp",
    disconnect: "Scollega",
    replaceWithNewPairing: "Sostituisci con un altro lettore",
    searchSerialPlaceholder: "Cerca per numero seriale…",
    showMockReaders: "Mostra terminali mock",
    noAvailableReaders:
      "Nessun lettore collegabile. Abbina prima un lettore SumUp in Gestione lettori.",
    selectReaderRequired:
      "Seleziona un lettore disponibile tramite numero seriale.",
    linkReplace: "Collega e sostituisci",
    linkReader: "Collega lettore",
    linkMockReader: "Collega lettore mock",
    unlinkConfirm:
      "Scollegare questo lettore dal tablet? L'abbinamento SumUp rimane; i pagamenti resteranno disabilitati finché non lo colleghi di nuovo.",
  },
} as const;
